/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '$legacyecstatic';
import MapboxLayer from 'editor/components/map/MapboxLayer';
import MapboxMap from 'editor/components/map/MapboxMap';
import { Components } from '../../components';

export const manageLayerComponents = [MapboxMap, MapboxLayer];

export function manageLayer(args: SystemFuncArgs<Components>): void {
  const { entity, components } = args;
  const mapComp = components.get(MapboxMap);
  const layerComp = components.get(MapboxLayer);

  if (!mapComp.map) return;

  if (entity.state === 'destroying') {
    if (layerComp.added) {
      mapComp.map.removeLayer(layerComp.tracked.layer.id);
    }

    return;
  }

  if (mapComp.map.loaded() && !layerComp.added) {
    const existingLayer = mapComp.map.getLayer(layerComp.tracked.layer.id);

    if (!existingLayer) {
      mapComp.map.addLayer(layerComp.tracked.layer as mapboxgl.AnyLayer);
    }

    layerComp.added = true;
  }
}
